import { StepUpAuthorizationError } from './fetchUtil'
import type { FetchOptions } from './fetchUtil'

let _oidcToken: string | undefined

export function setOidcToken(token: string | undefined) {
  _oidcToken = token
}

/**
 * Retrieves the API auth token from the top-level frame.
 * Standalone SPAs (KDS, Order Entry) are loaded in same-origin iframes
 * within the admin app, which stores the Bearer token on the global Page object.
 * Using window.top handles nested iframes (e.g. Order Entry inside KDS).
 */
export function getAuthToken(): string | undefined {
  if (_oidcToken) return _oidcToken
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (window.top as any)?.Page?.apiAuth?.AccessToken
  } catch {
    return undefined
  }
}

export function getRequestAuthOptions(stepUpToken?: string): FetchOptions {
  if (stepUpToken !== undefined) {
    return {
      authOverride: {
        token: stepUpToken,
        onUnauthorized: (method, url) =>
          new StepUpAuthorizationError(method, url, 401, 'invalid-token'),
        onForbidden: (method, url) =>
          new StepUpAuthorizationError(method, url, 403, 'insufficient-permission'),
      },
    }
  }

  return { token: getAuthToken() }
}
